var TableColumnEnum;
(function (TableColumnEnum) {
    TableColumnEnum["name"] = "name";
    TableColumnEnum["date"] = "date";
    TableColumnEnum["for"] = "for";
    TableColumnEnum["total"] = "total";
    TableColumnEnum["dueDate"] = "dueDate";
    TableColumnEnum["status"] = "status";
    TableColumnEnum["action"] = "action";
})(TableColumnEnum || (TableColumnEnum = {}));
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["paid"] = "Paid";
    StatusEnum["unpaid"] = "Unpaid";
    StatusEnum["overdue"] = "Overdue";
})(StatusEnum || (StatusEnum = {}));

var ROUTE_PREFIX = "/package/invoices";
var ROUTE_PACKAGE_VERSION = ROUTE_PREFIX + "/version";
var ROUTE_INVOICES = ROUTE_PREFIX + "/invoices";
var ROUTE_INVOICE_PUBLIC_URL = ROUTE_PREFIX + "/invoices/:id/public-url";
var ROUTE_UNPAID_OVERDUE_INVOICES = ROUTE_PREFIX + "/invoices/unpaid/overdue";

/* eslint-disable import/prefer-default-export */
var isVersionCompatible = function (feVersion, beVersion) {
    var feBreaking = feVersion.split(".")[0];
    var feIsNumber = !Number.isNaN(Number(feBreaking));
    var beBreaking = beVersion.split(".")[0];
    var beIsNumber = !Number.isNaN(Number(beBreaking));
    return feIsNumber && beIsNumber && beBreaking === feBreaking;
};

export { ROUTE_INVOICES, ROUTE_INVOICE_PUBLIC_URL, ROUTE_PACKAGE_VERSION, ROUTE_PREFIX, ROUTE_UNPAID_OVERDUE_INVOICES, StatusEnum, TableColumnEnum, isVersionCompatible };
//# sourceMappingURL=index.esm.js.map
